import * as React from 'react';
import { useEffect } from 'react';
import { toggleClass } from '@utils/ponyFills';

function getLoaderElement(): Element | null {
    if ( typeof document === 'undefined' ) {
        return null;
    }
    return document.querySelector( '.LoadingPage-overlay' );
}

export function LoadingFallback(): React.ReactElement {
    useEffect( () => {
        const loader = getLoaderElement();

        if ( loader ) {
            loader.classList.remove( 'off' );
            loader.classList.remove( 'fade-out' );
        }

        return () => {
            const loaderOnCleanup = getLoaderElement();
            if ( loaderOnCleanup ) {
                toggleClass( loaderOnCleanup, 'fade-out', true );
            }
        };
    }, [] );

    return <div />;
}
